import { render, staticRenderFns } from "./NameForm.vue?vue&type=template&id=e2ff81d0&"
import script from "./NameForm.vue?vue&type=script&lang=js&"
export * from "./NameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports